import { useListings } from '@pkgs/components/hooks/queries/useListings';
import { useAiSearch } from '@pkgs/components/hooks/queries/useAiSearch';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { Skeleton } from '../Skeleton/Skeleton';
import { formatNumber } from '../../utils/numberFormatters';
import { useAppContext } from '../../hooks/useAppContext';

export const TotalResultsCount = () => {
  const {
    t,
    options: { language },
  } = useAppContext();
  const { data, isFetching: isListingsFetching } = useListings();
  const { isPending: isAiSearchFetching } = useAiSearch();
  const isFetching = isListingsFetching || isAiSearchFetching;
  const formattedTotalResults = formatNumber({ number: data.listingsTotal || 0, language });

  return (
    <Skeleton loading={isFetching}>
      <Copy
        size="l"
        as="span"
        text={`${formattedTotalResults} ${t('search.searchbar.foundResults', {
          count: data.listingsTotal,
        })}`}
      />
    </Skeleton>
  );
};
